import { render, staticRenderFns } from "./order-tracking.vue?vue&type=template&id=84c6c984"
import script from "./order-tracking.vue?vue&type=script&lang=ts"
export * from "./order-tracking.vue?vue&type=script&lang=ts"
import style0 from "./order-tracking.vue?vue&type=style&index=0&id=84c6c984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports